import { createComponent } from '@carvana/merch-components';
import {
  HeaderWrapper,
  LinkCardContainer,
  LinksContainer
} from './LinkCard.styles';

export enum LinkCardType {
  VDP = 'vdp',
  SRP = 'srp'
}
type OwnProps = {
  card: LinkCardType;
};

const LoadingBlock = createComponent('div', {
  className: 'animate-pulse rounded-[6px] bg-background-skeleton'
});

function VDPLoadingBlock() {
  return (
    <div className="flex w-full items-center gap-16 py-16 first:pt-0 last:pb-0">
      <LoadingBlock className="h-[96px] w-[128px] flex-shrink-0" />
      <div className="flex w-full flex-col gap-8">
        <LoadingBlock className="h-16 w-full" />
        <LoadingBlock className="h-16 w-1/2" />
        <LoadingBlock className="h-16 w-1/2" />
      </div>
    </div>
  );
}

function SRPLoadingBlock() {
  return (
    <div className="flex w-full flex-col justify-center gap-8 py-32 first:pt-0 last:pb-0">
      <LoadingBlock className="h-16 w-2/3" />
      <LoadingBlock className="h-16 w-1/4" />
    </div>
  );
}

export default function LinksLoadingCard({ card }: OwnProps) {
  const isVdp = card === LinkCardType.VDP;
  const cards = Array.from({ length: isVdp ? 3 : 4 }, (_, i) => i);

  return (
    <LinkCardContainer>
      <HeaderWrapper>
        <LoadingBlock className="h-24 w-[128px]" />
        <LoadingBlock className="h-16 w-[80px]" />
      </HeaderWrapper>
      <LinksContainer>
        {cards.map((_, i) =>
          isVdp ? <VDPLoadingBlock key={i} /> : <SRPLoadingBlock key={i} />
        )}
      </LinksContainer>
    </LinkCardContainer>
  );
}
